<template>
  <div class="vc-home vc-ai-flex-start">
    <template>
      <div>
        <audio ref="alertSound">
          <source src="../assets/notify.wav" type="audio/mpeg" />
        </audio>
      </div>
    </template>
    <home-header :places="allPlaces" :currentPlace="currentPlace" />

    <v-row v-if="currentPlace" style="overflow: hidden ;" class="vc-home-content ma-0 mt-15 ml-5 mr-5 ">
      <v-col
        :cols="12"
        v-if="!currentPlace.forwarding"
        class="vc-w-100 ma-0 vc-flex-center mb-3"
      >
        <img height="48px" src="@/assets/img/vatm.png" alt="" style="z-index: 0;"/>
      </v-col>

      <v-col style="border: 1px solid #fff; border-radius: 10px; "
        :cols="currentPlace.forwarding ? 9 / 2 : 6"
        :class="currentPlace.forwarding ? 'pr-5 mb-2 mr-3' : 'vc-ai-flex-start adjust-responsive-col'"
      >
        <info-table :currentPlace="currentPlace" :lastPerson="lastPerson" />
      </v-col>

      <v-col style="border: 1px solid #fff; border-radius: 10px;"
        :cols="currentPlace.forwarding ? 9 / 2 :  6"
        :class="currentPlace.forwarding ? 'pr-5 mb-2 mr-3' : 'vc-ai-flex-start adjust-responsive-col'"
      >
        <info-table-preferential
          :currentPlace="currentPlace"
          :lastPerson="lastPerson"
        />
      </v-col>

      <v-col
        v-if="currentPlace.forwarding"
        
        class="pl-5"
        style="min-height: 400px"
      >
        <forward :places="allPlacesForward" :currentPlace="currentPlace" :lastPerson="lastPerson" />
      </v-col>

      <v-col cols="12" class="vc-flex-end">
        <button-with-dialog :currentPlace="currentPlace"></button-with-dialog>
      </v-col>
    </v-row>
    <v-container v-else class="container-scoped">
      <v-row class="vc-home-content  ml-5 mr-5">
        <v-col cols="12" class="pa-0 vc-flex-center">
          <select-place-message :places="allPlaces" />
        </v-col>
      </v-row>
    </v-container>
    <Footer />
  </div>
</template>

<script>
import ButtonWithDialog from "@/components/HomeComponents/ButtonWithDialog.vue";
import HomeHeader from "@/components/HomeComponents/Header.vue";
import InfoTable from "@/components/HomeComponents/InfoTable.vue";
import InfoTablePreferential from "@/components/HomeComponents/InfoTablePreferential.vue";
import Forward from "@/components/HomeComponents/Forward.vue";
import Footer from "@/components/HomeComponents/Footer.vue";
import SelectPlaceMessage from "@/components/HomeComponents/SelectPlaceMessage.vue";
import ls from "local-storage";

export default {
  name: "Home",
  components: {
    HomeHeader,
    InfoTable,
    Forward,
    Footer,
    SelectPlaceMessage,
    ButtonWithDialog,
    InfoTablePreferential,
  },
  mounted() {
    this.init();
    
  },
  created() {
    if (ls.get("currentPlace")) {
      this.$store.commit("SET_CURRENT_PLACE", ls.get("currentPlace"));
      this.$store.dispatch("setTokensByPlace", this.currentPlace);
    }
    if (ls.get("lastPerson")) {
      this.$store.commit("SET_LAST_PERSON", ls.get("lastPerson"));
    }
  },
  watch: {
    currentPlace(newVal, oldVal) {
      this.$store.commit("SET_LAST_PERSON", null);
      this.sockets.unsubscribe("new_queue");
      if (oldVal) {
        this.sockets.unsubscribe(`place_queue`);
        this.$socket.emit(`to_exit_place`, oldVal._id);
      }
      if (this.currentPlace.type === "KEYALL") {
        this.sockets.subscribe("new_queue", (data) => {
          this.$store.commit('ALL_QUEUES', [data])
          this.sendTable(data);
          this.$refs.alertSound.play();
          document.title = `Novo paciente (${this.allQueues.length})`;
        });
      } else {
        this.sockets.subscribe(`place_queue`, (data) => {
          this.sendTable(data);
          this.$refs.alertSound.play();
          this.$store.commit('ALL_QUEUES', [data]);
          console.log('TOTAL DE PESSOAS',this.allQueues.length);
          document.title = `Novo paciente (${this.allQueues.length})`;
        });
      }
      this.$socket.emit(`to_enter_place`, newVal._id);
    },
  },
  methods: {
    init() {
      this.sockets.subscribe("queueDelete", () => {
        console.log("entrei");
        this.$store.commit("SET_PEOPLE", []);
      });
      this.$store.dispatch("getAllPlaces");
      this.sockets.subscribe("remove_queue", (data) => {
        this.$store.commit("SET_REMOVE_PERSON", data);
      });
      localStorage.clear();
      console.log('pessoas',this.$store.getters.people)
    },
    sendTable(data) {
      this.$store.commit("SET_PUSH_PEOPLE", data);
    },
  },
  computed: {
    allPlacesForward() {
      return this.$store.getters.allPlacesForward;
    },
    allPlaces() {
      return this.$store.getters.allPlaces;
    },
    people() {
      return this.$store.getters.people;
    },
    currentPlace() {
      return this.$store.getters.currentPlace;
    },
    lastPerson() {
      return this.$store.getters.lastPerson;
    },
    allQueues() {
      return this.$store.getters.allQueues;
    }
  },
};
</script>
<style>
@media (max-width: 768px) {
  .container-scoped {
    top: 35vh !important;;
  }
  .adjust-responsive-col {
    max-width: 100%;
    margin-bottom: 5px ;
  }
}
.container-scoped {
  position: absolute;
  top: 40%;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
}
</style>
